var _circle, _path, _circle2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportReportFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 14,
    cy: 12.9,
    r: 1.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M28.8 37.5h-15c-3.1 0-5.7-2.5-5.7-5.7v-21c0-3.1 2.5-5.7 5.7-5.7H29c3.1 0 5.7 2.5 5.7 5.7v21.4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_sub",
    cx: 22.1,
    cy: 23.5,
    r: 8.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M19.1 16.2l3.4 7.4 7.7.8M22.5 23.6l4.3-6.7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportReportFull);
export default __webpack_public_path__ + "static/media/exportReportFull.6168fb50976837150552d7ecff251f2b.svg";
export { ForwardRef as ReactComponent };